<template>
<v-container fluid>
  <toast v-model="toastText"></toast>
  <gateway-bar v-if="!loading" :userId="userId" :enableAuth="!loading" :enableSearch="userId && userMac.length>0" @search="val=>searchWord=val" @compact="val=>compact=val" @popup="val=>toastText=val"></gateway-bar>
  <v-layout row v-if="loading">
    <progress-dialog>{{ $t('loading') }}</progress-dialog>
  </v-layout>
  <v-layout row justify-center v-else-if="userMac.length===0">
    <span class="title grey--text mt-5 text-xs-center">{{ $t('gateway.no_gateway_available' )}}</span>
  </v-layout>
  <v-layout row justify-center v-else-if="filteredMac.length===0">
    <span class="title grey--text mt-5 text-xs-center">{{ $t('gateway.no_gateway_matched' )}}</span>
  </v-layout>
  <v-layout row wrap v-else class="mt-2">
    <v-flex v-bind="itemLayout" v-for="mac in filteredMac" :key="mac['.key']" class="px-2 py-2">
      <detail-gateway :uid="userId" :mac="mac['.key']" :data="mac" :compact="compact" @popup="val=>toastText=val"></detail-gateway>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  UserAuth,
  GatewayItem,
  GatewayBar
} from 'luffanet-web-components'

export default {
  name: 'Gateway',
  mixins: [UserAuth],
  components: {
    'gateway-bar': GatewayBar,
    'detail-gateway': GatewayItem
  },
  data: function() {
    return {
      toastText: null,
      userMac: [],
      searchWord: null,
      loading: true,
      compact: true
    }
  },
  computed: {
    filteredMac() {
      let data = this.userMac;
      if(data && this.searchWord)
        data = data.filter(item => [
          item['.key'],
          item.uuid || '',
          item.address || '',
          item.hostname || '',
          item.map || '',
          (item.firmware || {}).version || ''
        ].join('#').toLowerCase().indexOf(this.searchWord.toLowerCase()) != -1);
      return data;
    },
    itemLayout() {
      return {
        [`xl${this.compact?3:4}`]: true,
        [`lg${this.compact?4:6}`]: true,
        [`md${this.compact?4:6}`]: true,
        [`sm${this.compact?6:12}`]: true
      }
    }
  },
  methods: {
    load() {
      this.$bindAsArray('userMac', this.$db.ref('userMac').child(this.userId), null, function() {
        this.loading = false;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway.vue